mutation RemoveContextDocument($input: ContextDocumentRemoveInput!) {
    contextDocumentRemove(input: $input) {
        id
    }
}
